var _typeof = require("../helpers/typeof");

var assertThisInitialized = require("./assertThisInitialized");

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@babel/runtime/helpers/possibleConstructorReturn.js
 ** module id = 17
 ** module chunks = 0
 **/